import { IAnimalRepository } from '../../../interfaces/gateways/animal.repository'

export default class ToggleCategory {
  constructor (
    private readonly animalRepository: IAnimalRepository
  ) {
  }

  execute (category: string): void {
    this.animalRepository.toggleCategory(category)
  }
}
